import { Box } from "@chakra-ui/react";
import Header from "components/Header";

const Layout = ({ children, isIframe = false }) => {
	return (
		<Box w="full" h="100vh" id="layout" backgroundColor="gray.200">
		<Header />
			<Box w="full" h={isIframe ? "full" : 0} mt={isIframe ? 0 : "100px"} px={isIframe ? 0 : "40px"}>
			{children}
			</Box>
		</Box>
	);
};

export default Layout;
